import type { RouteRecordRaw } from "vue-router"
import { useApplicationStore } from "@versatile-credit-apply/sdk"

export const TdBankDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "tdbank-apply-approved",
    path: "approved",
    component: () => import("./components/TdBankApproved.vue"),
  },
  {
    name: "tdbank-apply-pending",
    path: "pending",
    component: () => import("./components/TdBankPending.vue"),
  },
  {
    name: "tdbank-apply-declined",
    path: "declined",
    component: () => import("./components/TdBankDeclined.vue"),
  },
  {
    name: "tdbank-apply-error",
    path: "error",
    component: () => import("./components/TdBankError.vue"),
  },
]

export const TdBankApplyRoutes: RouteRecordRaw[] = [
  {
    name: "tdbank-apply-routes",
    path: "tdbank_standard",
    children: [
      {
        name: "tdbank-apply-start",
        path: "start/:mode",
        redirect: "/apply/workflows/pre-application",
        meta: {
          step: "applicant",
        },
      },
      {
        name: "tdbank-terms",
        path: "terms",
        component: () => import("./pages/TdBankTermsAndConditionsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "tdbank-review-application",
        path: "application/done",
        component: () => import("./pages/TdBankReviewInformationPage.vue"),
        meta: {
          next: "../terms",
          step: "applicant",
        },
      },
      {
        name: "tdbank-apply-decisions",
        path: "decision",
        component: () => import("./pages/TdBankDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: TdBankDecisionRoutes,
      },
    ],
  },
]
